import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// report-common
import { getReportSelectors } from '../../../report-common';
//////////////////////////////////////////////////

const {
  store,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectFilterParams,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
} = getReportSelectors('driverPayrollInvoices');

const makeSelectItemList = () => createSelector(
  store,
  ({ itemList }) => R.sortBy(R.prop('index'), R.values(itemList)),
);

const makeSelectConfigs = () => createSelector(
  store,
  ({ configs }) => ({
    driverPayrollInvoicesStatuses: G.createOptionsFromDropdownConfigWithGuidOrParentGuid(
      configs,
      GC.INVOICE_FI_STATUS,
      true,
    ),
    allowExportDriverInvoice: G.getConfigValueFromStore(
      GC.INVOICE_TEL_DRIVER_INVOICE_EXPORT,
      configs,
    ),
  }),
);

export {
  makeSelectConfigs,
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectFilterParams,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
};

